// extracted by mini-css-extract-plugin
export default {"manageGifList":"ManageGifList_manageGifList__MYQ8O","labelsWrapper":"ManageGifList_labelsWrapper__aNx78","list":"ManageGifList_list__-bP6Y","labels":"ManageGifList_labels__VWQk8"};